
<template>
  <span>

    <a href="#" class="btn btn-link btn-light p-1 mb-1" @click="openmap" style="color:inherit;">{{text}}<i class="icon-pin-alt"></i></a>

    <modal-in-front v-bind:title="map" ref="thisModal" size="modal-md">
      <div style="margin:auto;overflow:visible;position:relative">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <location-autocomplete @changed="adressChanged"></location-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <map-component width="100%" style="height:60vh" ref="map" @clicked_on_map="didClick" v-bind:zoomlevel="zoomlevel"></map-component>
            </div>
          </div>
        </div>
        
      </div>
    </modal-in-front>
  </span>

</template>

<script>

  import ModalInFront from "../modals/modal-in-front.vue";
  import MapComponent from "../maps/Map-component.vue";
  var infoIconUrl = "https://developers.google.com/maps/documentation/javascript/examples/full/images/info-i_maps.png";

  export default {
    name: 'map-button',
    components: {
      MapComponent,
      ModalInFront
    },
    props: {
      adress: {
        required: false,
        type: String,
        default: null
      },
      longitude:{
        required: false,
        type: String,
        default: null
      },
      latitude: {
        required: false,
        type: String,
        default: null
      },
      onMapclick: {
        required: false,
        type: String,
        default: null
      },
      zoomlevel: {
        required: false,
        type: Number,
        default: 13
      },
      text: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        infoIconUrl
      }
    },
    methods: {
      adressChanged(adress, lat, lng) {
        this.$refs.map.setCenter(parseFloat(lat), parseFloat(lng));
        this.setMarker(parseFloat(lat), parseFloat(lng))
        this.didClick(parseFloat(lat), parseFloat(lng))
      },
      getId() {
        return this._uid;
      },
      didClick(lat, lng) {
        if (this.onMapclick != null) {
          eval(this.onMapclick + "(lat,lng)")
        }
        this.$emit("on_map_click", lat, lng);
      },
      openmap() {

        if (typeof (window.geocoder) == 'undefined') {
          //setTimeout(function () {
            window.geocoder = new google.maps.Geocoder();
          //}, 2000)
        }
        var thisContext = this;
        if (typeof (window.geocoder) != 'undefined') {

          if (this.longitude == null && this.latitude == null && this.adress != null) {
            window.geocoder.geocode({ 'address': this.adress }, function (results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                var lat = results[0].geometry.location.lat();

                var lng = results[0].geometry.location.lng();
                thisContext.$refs.map.setMarkers([{
                  id: "a",
                  position: { lat: lat, lng: lng },
                }]);
                thisContext.$refs.map.setCenter(lat, lng);
                thisContext.$refs.thisModal.open();
              }
            });
          } else if (this.longitude == "0" && this.latitude == "0" && this.adress == null) {
            
            setTimeout(function () {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(thisContext.showMapPosition, thisContext.positionError);
              } else {
                alert("Geolocation is not supported by this browser.");
              }
            }, 100)
            thisContext.$refs.thisModal.open();

          }
          else if (this.longitude != null && this.latitude != null && this.adress == null) {
            thisContext.$refs.map.setCenter(this.latitude, this.longitude);
            thisContext.$refs.map.setMarkers([{
              id: "a",
              position: { lat: this.latitude, lng: this.longitude },
            }]);
            thisContext.$refs.map.setCenter(this.latitude, this.longitude);
            thisContext.$refs.thisModal.open();
          }
          else {

            setTimeout(function () {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(thisContext.showMapPosition, thisContext.positionError);
              } else {
                alert("Geolocation is not supported by this browser.");
              }
            }, 100)

            thisContext.$refs.thisModal.open();

          }
        }
      },
      positionError() {
        alert("Some error")
      },
      showMapPosition(position) {
        
        if (typeof position.coords.latitude == "undefined") {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          
          this.$refs.map.setMarkers([{
            id: "a",
            position: { lat: this.latitude, lng: this.longitude },
          }]);
          thisContext.$refs.map.setCenter(this.latitude, this.longitude);
        }
        else {
          this.$refs.map.centerOnAddress("Oslo");
        }
        
        
      },
      setMarker(lat, lng) {
        this.$refs.map.setMarkers([{
          id: "a",
          position: { lat: lat, lng: lng },
        }]);
        this.$forceUpdate();
      }
    },
    created() {

    },
    mounted() {
      
    }
  }
</script>



<style scoped>
  .btn-outline-grey {
    color: #aaa;
    border-color: #aaa;
  }

    .btn-outline-grey:not(:disabled):not(.disabled).active, .btn-outline-grey:not(:disabled):not(.disabled):active, .show > .btn-outline-grey {
      color: #fff;
      background-color: #aaa;
      border-color: #aaa;
    }
</style>



// WEBPACK FOOTER //
// src/components/maps/map-button.vue